import { useTranslation } from 'react-i18next';
import { FC } from "react";
import CustomCard from "../../../../custom-card/CustomCard";
import { Col, Form, Row, Tag } from "antd";
import "../student-detail/studentDetail.scss";
interface StudentDetailProps {
  studentRecord: any;
  specialized: string[];
}

const StudentDetail: FC<StudentDetailProps> = ({
  studentRecord,
  specialized,
}) => {
    const { t } = useTranslation();
  return (
    <section className="wrapper-settings category-management-detail">
      <div className="setting-student wrapper-inside">
        <CustomCard className="header-card" title={t("Thông tin danh mục dùng chung")}>
          <Form.Item className="setting-item" name="name" label={t("Tên sinh viên")}>
            <p className="student-content">{studentRecord?.name}</p>
          </Form.Item>
          <Form.Item className="setting-item" name="code" label={t("Mã sinh viên")}>
            <p className="student-content">{studentRecord?.code}</p>
          </Form.Item>
          <Form.Item className="setting-item" name="gender" label={t("Giới tính")}>
            <p className="student-content">{studentRecord?.gender ? (t(studentRecord?.gender, studentRecord?.gender) as string) : ""}</p>
          </Form.Item>
          <Form.Item className="setting-item" name="department" label={t("Khoa", "Khoa")}>
            <p className="student-content">{studentRecord?.industryGroupInfo?.name}</p>
          </Form.Item>
          <Form.Item className="setting-item" name="domicile" label={t("Nguyên quán")}>
            <p className="student-content">{studentRecord?.provinceDto?.name}</p>
          </Form.Item>
          <Form.Item className="setting-item" name="universityName" label={t("Tên trường")}>
            <p className="student-content">{studentRecord?.universityName}</p>
          </Form.Item>
          <Form.Item className="setting-item" name="specialized" label={t("Chuyên ngành")}>
            <div className="student-content">
              {specialized?.map((item: any) => (
                <Tag key={item}>
                  {item}
                </Tag>
              ))}
            </div>
          </Form.Item>
          <Form.Item className="setting-item" name="email" label="Email">
            <p className="student-content">{studentRecord?.email}</p>
          </Form.Item>
          <Form.Item className="setting-item" name="phone" label={t("Điện thoại liên hệ")}>
            <p className="student-content">{studentRecord?.phoneNumber}</p>
          </Form.Item>
        </CustomCard>
      </div>
    </section>
  )
}
export default StudentDetail;